import React from "react";

export const NotificationSupport = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#C8C8C8" />
      <path
        d="M34.8182 21.6657L31.2975 23.0335L30.2437 25.5759L31.7675 29.039L29.2572 31.5492L25.7942 30.0254L23.2524 31.0787L21.8846 34.5994H18.3341L16.9663 31.0787L14.4239 30.0249L10.9608 31.5487L8.45108 29.0389L9.97491 25.5759L8.92108 23.0337L5.40039 21.6659V18.1154L8.92108 16.7476L9.97491 14.2052L8.45108 10.7421L10.9609 8.23233L14.4239 9.75615L16.9662 8.70233L18.3339 5.18164H21.8843L23.252 8.70233L25.7946 9.75615L29.2578 8.23233L31.7679 10.7426L30.2441 14.2056L31.2975 16.7474L34.8182 18.1152V21.6657Z"
        fill="#92929D"
      />
      <path
        d="M20.1094 28.7031C24.9764 28.7031 28.9219 24.7576 28.9219 19.8906C28.9219 15.0236 24.9764 11.0781 20.1094 11.0781C15.2424 11.0781 11.2969 15.0236 11.2969 19.8906C11.2969 24.7576 15.2424 28.7031 20.1094 28.7031Z"
        fill="#B4B4B7"
      />
      <path
        d="M25.2499 20.8769L21.0956 25.0311L16.4221 23.4732L14.8643 18.7998L19.0185 14.6455L23.692 16.2033L25.2499 20.8769Z"
        fill="#92929D"
      />
      <path
        d="M20.1094 21.3594C20.9205 21.3594 21.5781 20.7018 21.5781 19.8906C21.5781 19.0795 20.9205 18.4219 20.1094 18.4219C19.2982 18.4219 18.6406 19.0795 18.6406 19.8906C18.6406 20.7018 19.2982 21.3594 20.1094 21.3594Z"
        fill="#73737E"
      />
    </svg>
  );
};
